if (!customElements.get('colour-matched-products')) {
  class ColourMatchedProducts extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.js-product');
      this.picker = this.section?.querySelector('variant-picker');
      this.results = this.querySelector('[data-match-results]');
      if (!this.section || !this.results) return;
      try {
        this.colours = JSON.parse(this.querySelector('[data-match-source]').textContent);
      } catch (_) {
        return;
      }
      this.onVariantChange = (event) => {
        if (event.target !== this.picker) return;
        this.showColour(event.detail?.variant?.id);
      };
      this.onChoice = (event) => {
        if (!event.target.matches('[data-match-choice]')) return;
        const card = event.target.closest('[data-match-card]');
        const panels = [...card.querySelectorAll('[data-match-panel]')];
        const selected = event.target.value;
        const activePanel = panels.find((panel) => panel.dataset.matchPanel === selected);
        if (!activePanel) return;
        const choice = event.target;
        const control = choice.closest('.colour-match__choice');
        const restoreFocus = document.activeElement === choice;
        const actions = activePanel.querySelector('[data-match-actions]');
        actions.prepend(control);
        panels.forEach((panel) => {
          const active = panel === activePanel;
          panel.hidden = !active;
          panel.querySelector('[name="add"]').disabled = !active;
        });
        if (restoreFocus) choice.focus({ preventScroll: true });
      };
      this.section.addEventListener('on:variant:change', this.onVariantChange);
      this.addEventListener('change', this.onChoice);
      this.showColour(this.picker?.variant?.id || this.dataset.initialVariant);
    }

    disconnectedCallback() {
      this.section?.removeEventListener('on:variant:change', this.onVariantChange);
      this.removeEventListener('change', this.onChoice);
    }

    showColour(variantId) {
      const colour = this.colours[String(variantId)];
      if (colour === this.currentColour) return;
      this.currentColour = colour;
      const template = [...this.querySelectorAll(':scope > template[data-match-colour]')]
        .find((item) => item.dataset.matchColour === colour);
      this.results.replaceChildren(...(template ? [template.content.cloneNode(true)] : []));
      this.hidden = !this.results.querySelector('[data-match-card]');
    }
  }
  customElements.define('colour-matched-products', ColourMatchedProducts);
}
